<template>
  <!-- WMS-Kachelseite (Trello 21.08.): 3 Spalten, Icon mittig, Text unten, nur erlaubte Kacheln -->
  <div class="m-wms-home">
    <router-link v-for="t in visibleTiles" :key="t.path" :to="t.path" class="m-wms-tile">
      <span class="material-symbols-outlined">{{ t.icon }}</span>
      <span class="m-wms-tile__label" lang="de">{{ $t(t.label) }}</span>
    </router-link>
    <p v-if="!visibleTiles.length" class="m-hint">{{ $t("mobile.wms.noAccess") }}</p>
  </div>
</template>

<script>
import { isAdmin, canView, hasPermission } from "@/mixins/auth";

export default {
  name: "MWmsHome",
  computed: {
    visibleTiles() {
      const admin = isAdmin();
      const tiles = [
        // Icons exakt wie vom Kunden benannt (Google Material Symbols)
        { path: "/m/lager/bestand", icon: "inventory_2", label: "layout.wms.inventory", ok: admin || canView("Inventories") },
        { path: "/m/lager/wms", icon: "warehouse", label: "layout.wms.warehouses", ok: admin || canView("Warehouses") },
        { path: "/m/lager/wareneingang", icon: "deployed_code_update", label: "mobile.wms.incomingGoods", ok: hasPermission("Write", "Warehouses", "IncomingGoods") },
        { path: "/m/lager/umlagerung", icon: "text_select_move_forward_word", label: "mobile.wms.movement", ok: hasPermission("Write", "Warehouses", "Movement") },
        { path: "/m/lager/anpassung", icon: "orders", label: "mobile.wms.manualAdjustment", ok: hasPermission("Write", "Warehouses", "ManualAdjustment") },
        { path: "/m/lager/inventur", icon: "inventory", label: "mobile.wms.stocktaking", ok: hasPermission("Write", "Warehouses", "ManualAdjustment") },
        { path: "/m/lager/lagerplaetze", icon: "shelves", label: "layout.wms.storagelocations", ok: admin || canView("StorageLocations") },
      ];
      return tiles.filter((t) => t.ok);
    },
  },
};
</script>

<style lang="scss" scoped>
.m-wms-home {
  display: grid;
  // minmax(0, ...): lange Woerter ("Bestandsuebersicht") duerfen die Spalte nicht aufweiten
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  padding: 16px 12px;
}
.m-wms-tile {
  aspect-ratio: 1;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-decoration: none;
  color: #37474f !important; // globale Link-Farbe (lila) uebersteuern
  padding: 8px;
  min-width: 0;

  .material-symbols-outlined {
    font-size: 40px;
    color: #7f915a;
  }

  &__label {
    font-size: 11px;
    font-weight: 600;
    text-align: center;
    line-height: 1.25;
    color: #37474f;
    overflow-wrap: break-word;
    hyphens: auto;
  }
}
.m-hint {
  grid-column: 1 / -1;
  text-align: center;
  color: #9e9e9e;
}
</style>
